import { render, staticRenderFns } from "./NavbarLegacy.vue?vue&type=template&id=5af8b9e4"
import script from "./NavbarLegacy.vue?vue&type=script&lang=js"
export * from "./NavbarLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports